import{__require as r}from"./symbol-constructor-detection.js";var o,t;function e(){if(t)return o;t=1;var e=r();return o=e&&!Symbol.sham&&"symbol"==typeof Symbol.iterator}export{e as __require};
//# sourceMappingURL=use-symbol-as-uid.js.map
